/* eslint-disable no-magic-numbers */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Heading, Paragraph } from '@scentregroup/ui'
import classNames from 'classnames'
import { truncateString } from '../../helpers/string-helpers'
import analyticsUtils from '../../helpers/analytics-utils'
import Article from '../article'
import IconRow from '../icon-row'
import { trackingActions, trackingTypes } from '../../constants'
import Trackable from '../trackable'
import style from './index.scss'
import Logo from './logo'

const VisibleStores = ({ stores, searchValue, isListView, option }) => {
  if (!stores) {
    return null
  }

  const handleAnalytics = item => {
    const eventAction =
      option && option.level > 1
        ? analyticsUtils.actions.STORE_SUB_CATEGORY_CLICKED
        : analyticsUtils.actions.STORE_CATEGORY_CLICKED
    const action =
      option && option.level
        ? eventAction
        : analyticsUtils.actions.SEARCH_RESULT_ClICKED
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.SEARCH,
      eventCategory: analyticsUtils.categories.STORE_SEARCH,
      eventAction: action,
      eventLabel: searchValue,
      storeResultClicked: item.title,
    })
  }

  const getLongDescription = item => {
    const longDescription =
      item.longDescription ||
      (item.retailer && item.retailer.longDescription) ||
      ''

    return truncateString(longDescription, 200, { ellipse: '\u2026' })
  }
  if (isListView) {
    return (
      <div className={style.storeList}>
        {stores.map(item => {
          const longDescription = getLongDescription(item)
          return (
            <Trackable
              key={item.link}
              trackingAction={trackingActions.viewPromotion}
              type={trackingTypes.promotion}
              {...item.analyticsMetadata}
            >
              <div className={style.storeItem} data-test-id="store-item-list">
                <div
                  className={style.logoContainer}
                  data-test-id="store-logo-list"
                >
                  <Link to={item.link} onClick={() => handleAnalytics(item)}>
                    <Logo name={item.title} logo={item.logo} />
                  </Link>
                </div>
                <Article
                  dataTestId="store-name-list"
                  heading={item.title}
                  link={item.link}
                  className={style.itemArticle}
                  location={item.landmarkDescription}
                  hoursText={item.hoursText}
                  onClick={() => handleAnalytics(item)}
                >
                  {longDescription && (
                    <Paragraph type="medium" className={style.summary}>
                      {longDescription}
                    </Paragraph>
                  )}
                </Article>
              </div>
            </Trackable>
          )
        })}
      </div>
    )
  } else {
    return (
      <div className={style.storeGrid}>
        {stores.map(item => (
          <div
            key={item.link}
            className={style.storeItem}
            data-test-id="store-item-grid"
          >
            <Trackable
              trackingAction={trackingActions.viewPromotion}
              type={trackingTypes.promotion}
              {...item.analyticsMetadata}
            >
              <Link
                to={item.link}
                className={classNames(style.storeGridItem, style.headingLink)}
                onClick={() => handleAnalytics(item)}
              >
                <div
                  className={style.logoContainer}
                  data-test-id="store-logo-grid"
                >
                  <Logo name={item.title} logo={item.logo} />
                </div>
                <Heading type="small" data-test-id="store-name-grid">
                  {item.title}
                </Heading>
              </Link>
              <IconRow text={item.hoursText} />
            </Trackable>
          </div>
        ))}
      </div>
    )
  }
}

VisibleStores.propTypes = {
  stores: PropTypes.array.isRequired,
  searchValue: PropTypes.string,
  isListView: PropTypes.bool,
  option: PropTypes.object,
}

VisibleStores.defaultProps = {
  searchValue: null,
  isListView: false,
  option: null,
}

export default VisibleStores
